module.exports = __webpack_public_path__ + "img/meals.22bbcb3b.jpg";